import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const IchraxTheme = definePreset(Aura, {
    //Your customizations, see the following sections for examples
    components: {
        // custom button tokens and additional style
        select: {
            css: `
                borderRadius: '4px'
            `
        },

    },
    // treetable: {
    //     headerCell: {
    //         sortedBackground: 'transparent',
    //         sortedColor: '{text.900}'
    //     }
    // },
    // table: {
    //     headerCell: {
    //         sortedBackground: 'transparent',
    //         sortedColor: '{text.900}'
    //     }
    // }
    semantic: {
        primary: {
            50: 'var(--primary-50)', // was -10
            100: 'var(--primary-100)', // was -10
            200: 'var(--primary-200)', // was -20
            300: 'var(--primary-300)', // was -30
            400: 'var(--primary-400)', // was -40
            500: 'var(--primary-500)', // was -50
            600: 'var(--primary-600)', // was -60
            700: 'var(--primary-700)', // was -70
            800: 'var(--primary-800)', // was -80
            900: 'var(--primary-900)', // was -90
            950: 'var(--primary-900)' // was -95
        }
    },
});

export { IchraxTheme };
